export default "__VITE_ASSET__CSSEy2ho__"